export default "__VITE_ASSET__BEXKdJJh__ 640w, __VITE_ASSET__DoCwDb2k__ 1024w, __VITE_ASSET__BSoh8uXH__ 1280w";